module.exports = __webpack_public_path__ + "facelifting_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_7_before.jpg
// module id = 1062
// module chunks = 0